import { useAuth } from "@/context"
import { AuthPage } from "@/pages/auth"

import { createFileRoute, redirect } from "@tanstack/react-router"

function LoadingSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="h-12 w-12 animate-spin rounded-full border-b-2 border-primary"></div>
    </div>
  )
}

function AuthRoute() {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingSpinner />
  }

  if (user) {
    throw redirect({ to: "/dashboard" })
  }

  return <AuthPage />
}

export const Route = createFileRoute("/auth")({
  component: AuthRoute,
})
